<template>
  <component :style="getStyleObject()" :is="componentLoader('ColumnText')">
    <h2 slot="title" class="short-border-bottom">{{ data.title.data }}</h2>
    <p slot="text" v-html="data.text.data"></p>
  </component>
</template>
<script>
  import settings from '@fremcast/section/mixins/section';
  import card from '@fremcast/section/mixins/card';
  export default {
    data() {
      return {
        cols: 's12 l4'
      };
    },
    methods: {
      getStyleObject() {
        const style = this.fetchSettings.style;

        return {
          ...{
            backgroundColor: style.backgroundColor,
            color: style.fontColor,
            "padding-left": style.paddingTop + 'px',
            "padding-top": style.paddingTop + 'px',
            "padding-right": style.paddingTop + 'px',
            "padding-bottom": style.paddingBottom + 'px'
          },
          ...this.getBorderStyle()
        }
      },
      getBorderStyle() {
        const border = this.fetchSettings.style.border;
        const borderValues =  border.style + ' ' +  border.size + 'px ' + border.color;

        if (border.style === 'none') {
          return {
            border: 'none'
          }
        }

        return {
          "border-left": border.left ? borderValues : 'none',
          "border-top": border.top ? borderValues : 'none',
          "border-right": border.right ? borderValues : 'none',
          "border-bottom": border.bottom ? borderValues : 'none',
        }
      }
    },
    props: [
      'data'
    ],
    mixins: [
      settings,
      card
    ]
  }
</script>
<style scoped>
  .row {
    margin: 15px;
  }
</style>